function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useState } from "react";
import { Pressable, View } from "react-native";
import { Separator as DefaultSeparator } from "../Separator.component";
import { useBiblo } from "../../hooks/Biblo.hook";
import { Typography, TypographySize } from "../Typography.component";
import { getViewStyles } from "../../helpers/getStyles.helper";
import { ErrorBoundary } from "../ErrorBoundary.component";
export const IndexItem = _ref => {
  let {
    file
  } = _ref;
  const [active, setActive] = useState(false);
  const {
    selectedFile,
    setSelectedFile,
    onSelectFile,
    indexOptions,
    defaultStyles,
    disableDefaultStyles: disableDefaultStylesGlobal,
    textParser
  } = useBiblo();
  const disableDefaultStyles = disableDefaultStylesGlobal || indexOptions.disableDefaultStyles;
  const onPress = useCallback(() => {
    const setAsActive = selectedFile !== file.path || !indexOptions.sectionItemToggleOnPress;
    setActive(setAsActive);
    setSelectedFile(setAsActive ? file.path : undefined);
    if (setAsActive && onSelectFile) {
      onSelectFile(file.path);
    }
  }, [selectedFile, setSelectedFile, onSelectFile, file, indexOptions]);
  const Container = indexOptions.sectionItemComponent || View;
  const Separator = indexOptions.sectionItemSeparator || (props => /*#__PURE__*/React.createElement(DefaultSeparator, _extends({
    disableDefaultStyles: disableDefaultStyles
  }, props)));
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the item"
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      height: indexOptions.sectionListItemHeight
    },
    title: file.title,
    subtitle: file.subtitle,
    titleStyle: indexOptions.sectionItemTitleStyle,
    subtitleStyle: indexOptions.sectionItemSubtitleStyle,
    active: active,
    onPress: onPress
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: onPress,
    style: getViewStyles(indexOptions.sectionItemStyle, {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: defaultStyles.spacing
    }, disableDefaultStyles)
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the title"
  }, /*#__PURE__*/React.createElement(Typography, {
    style: indexOptions.sectionItemTitleStyle,
    disableDefaultStyles: disableDefaultStyles
  }, textParser(file.title, {
    type: "title",
    screen: "index",
    scope: "file",
    style: indexOptions.sectionItemTitleStyle
  }))), file.subtitle && !indexOptions.sectionItemSubtitleHidden && /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the subtitle"
  }, /*#__PURE__*/React.createElement(Typography, {
    size: TypographySize.Small,
    style: indexOptions.sectionItemSubtitleStyle,
    disableDefaultStyles: disableDefaultStyles
  }, textParser(file.subtitle, {
    type: "subtitle",
    screen: "index",
    scope: "file",
    style: indexOptions.sectionItemSubtitleStyle
  })))), indexOptions.sectionItemSeparatorHidden || /*#__PURE__*/React.createElement(Separator, {
    style: indexOptions.sectionItemSeparatorStyle
  })));
};
//# sourceMappingURL=IndexItem.component.js.map